module.exports = __webpack_public_path__ + "img/DW365-030.b5b0ac1a.jpg";